/**
 * Created by Andrey Popov on 10/8/25.
 */

const PathPointsView = function (path) {
    const mapView = Map2d.currentMap.getMapView();
    let iconPath = path;
    if (path.length > 2) {
        const smoothPath = this.smoothPath(path);
        iconPath = this.distributePathPoints(smoothPath);
    }
    this.pathIcons = iconPath.map((point) => {
        const pathIcon = new cleverapps.Spine(bundles.path_sign.jsons.waypoint_json);
        pathIcon.setVisible(false);
        pathIcon.setPosition(mapView.alignInGrid(point.x, point.y));
        mapView.cloudsAbove.addChild(pathIcon);
        const cellX = Math.round(point.x);
        const cellY = Math.round(point.y);
        const isFog = Map2d.currentMap.isOccupiedByFog(cellX, cellY);
        const localZOrder = isFog
            ? mapView.getFogViewLocalZOrder(cellX, cellY)
            : mapView.getAdditionalViewLocalZOrder(cellX, cellY);
        pathIcon.setLocalZOrder(localZOrder - 1);
        return pathIcon;
    });

    this.showUp();
};

PathPointsView.SMOOTHING_PASSES = 4;
PathPointsView.SMOOTHING_LAMBDA = 0.4;
PathPointsView.PATH_ICONS_DISTANCE_MULTIPLIER = 1.5;

PathPointsView.prototype.smoothPath = function (pathPoints) {
    for (let pass = 0; pass < PathPointsView.SMOOTHING_PASSES; pass++) {
        const previousPoints = pathPoints;
        pathPoints = previousPoints.map((point, i) => {
            if (i === 0 || i === previousPoints.length - 1) {
                return cc.p(point.x, point.y);
            }

            return cc.p(
                point.x + PathPointsView.SMOOTHING_LAMBDA
                    * ((previousPoints[i - 1].x + previousPoints[i + 1].x) / 2 - point.x),
                point.y + PathPointsView.SMOOTHING_LAMBDA
                    * ((previousPoints[i - 1].y + previousPoints[i + 1].y) / 2 - point.y)
            );
        });
    }
    return pathPoints;
};

PathPointsView.prototype.distributePathPoints = function (pathPoints) {
    let pathDistance = 0;
    for (let i = 1; i < pathPoints.length; i++) {
        pathDistance += cc.pDistance(pathPoints[i - 1], pathPoints[i]);
    }

    const intervalsCount = pathPoints.length - 1;
    const sparseIntervalsCount = Math.round(intervalsCount / PathPointsView.PATH_ICONS_DISTANCE_MULTIPLIER);
    const distributedPointsCount = sparseIntervalsCount + 1;
    const distanceStep = pathDistance / sparseIntervalsCount;
    let segment = 1;
    let segmentStartDistance = 0;
    let segmentEndDistance = cc.pDistance(pathPoints[0], pathPoints[1]);

    return Array.from({ length: distributedPointsCount }, (_, i) => {
        let point;
        if (i === 0) {
            point = pathPoints[0];
        } else if (i === distributedPointsCount - 1) {
            point = pathPoints[pathPoints.length - 1];
        } else {
            const targetDistance = i * distanceStep;
            while (segmentEndDistance < targetDistance) {
                segmentStartDistance = segmentEndDistance;
                segment++;
                segmentEndDistance += cc.pDistance(pathPoints[segment - 1], pathPoints[segment]);
            }

            const segmentProgress = (targetDistance - segmentStartDistance) / (segmentEndDistance - segmentStartDistance);
            point = cc.p(
                pathPoints[segment - 1].x + (pathPoints[segment].x - pathPoints[segment - 1].x) * segmentProgress,
                pathPoints[segment - 1].y + (pathPoints[segment].y - pathPoints[segment - 1].y) * segmentProgress
            );
        }
        return point;
    });
};

PathPointsView.prototype.showUp = function () {
    this.pathIcons.slice().reverse().forEach((pathIcon, i) => {
        pathIcon.stopAllActions();

        pathIcon.runAction(new cc.Sequence(
            new cc.DelayTime(Math.min(3, 0.3 + i * 0.05)),
            new cc.Show(),
            new cc.SpineAction(pathIcon, "showUp", undefined, () => {
                pathIcon.setAnimation(0, "idle", true);
            })
        ));
    });
};

PathPointsView.prototype.hide = function (silent) {
    this.pathIcons.forEach((pathIcon) => {
        pathIcon.stopAllActions();
        if (silent) {
            pathIcon.removeFromParent();
        } else {
            pathIcon.runAction(new cc.Sequence(
                new cc.SpineAction(pathIcon, "hide"),
                new cc.RemoveSelf()
            ));
        }
    });
    this.pathIcons = [];
};